import axios from "axios/index";
import api from "../../config/_api";
import {SYSTEM_TYPE_UPDATED} from "../actions/system_type";

const state = {
    system_type: []
};
const actions = {
    getTypes: ({commit, rootGetters}) => {
        axios({url: api.url + 'systemsType', method: 'GET' })
            .then(resp => {
                commit('SYSTEM_TYPE_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
};
const mutations = {
    [SYSTEM_TYPE_UPDATED]: (state, system_type) => {
        system_type.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        state.system_type = system_type;
    },
};
const getters = {
    system_type : state => state.system_type,
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
